import moment from "moment";
const { REACT_APP_IMAGE_URL } = process.env;

const EncodeImageDataUrl = (surveyDetails) => {
  {
    let fileEncodeData = surveyDetails.companyLogoURLEncode;
    if (
      surveyDetails.companyLogoURLEncode === null ||
      surveyDetails.companyLogoURLEncode === undefined ||
      surveyDetails.companyLogoURLEncode == ""
    ) {
      return "";
    } else {
      return fileEncodeData;
    }
  }
};

const DateFormat = (props) => {
  return <span>{moment(props.date).format("MM/DD/YYYY h:mm A")}</span>;
};

const DaysDifferent = (props) => {
  return Number(moment(props.start_date).startOf("day").diff(moment(props.expiry_date).startOf("day"), "days"));
};

const SurveyStartDate = (props) => {
  return (
    <>
      {Number(moment(props.start_date).startOf("day").diff(moment(Date.now()).startOf("day"), "days")) < 1 ? (
        <>
          <span className="start_date">Opened on:</span>{" "}
          <span>{moment(props.start_date).format("MM/DD/YYYY h:mm A")}</span>{" "}
        </>
      ) : (
        <>
          <span className="start_date">Opens on:</span>{" "}
          <span>{moment(props.start_date).format("MM/DD/YYYY h:mm A")}</span>{" "}
        </>
      )}
    </>
  );
};

const SurveyEndDate = (props) => {
  return (
    <>
      {Number(moment(props.end_date).startOf("day").diff(moment(Date.now()).startOf("day"), "days")) < 1 ? (
        <>
          <span className="end_date">Closed on:</span> <DateFormat date={props.end_date} />
        </>
      ) : (
        <>
          <span className="end_date">Closes on:</span> <DateFormat date={props.end_date} />
        </>
      )}
    </>
  );
};

const SurveyNote = (props) => {
  return (
    <>
      {Number(moment(props.end_date).startOf("day").diff(moment(Date.now()).startOf("day"), "days")) < 1 ? (
        <></>
      ) : (
        <>
          <small className="note">This data is not final as the survey is ongoing.</small>
        </>
      )}
    </>
  );
};

const ExcelSurveyStartLabel = (start_date) => {
  if (Number(moment(start_date).startOf("day").diff(moment(Date.now()).startOf("day"), "days")) < 1) {
    return "Opened on";
  } else {
    return "Opens on";
  }
};

const ExcelSurveyEndLabel = (end_date) => {
  if (Number(moment(end_date).startOf("day").diff(moment(Date.now()).startOf("day"), "days")) < 1) {
    return "Closed on:";
  } else {
    return "Closes on:";
  }
};

const ExcelSurveyStartDate = (start_date) => {
  if (Number(moment(start_date).startOf("day").diff(moment(Date.now()).startOf("day"), "days")) < 1) {
    return moment(start_date).format("MM/DD/YYYY h:mm A");
  } else {
    return moment(start_date).format("MM/DD/YYYY h:mm A");
  }
};

const ExcelSurveyEndDate = (end_date) => {
  if (Number(moment(end_date).startOf("day").diff(moment(Date.now()).startOf("day"), "days")) < 1) {
    return moment(end_date).format("MM/DD/YYYY h:mm A");
  } else {
    return moment(end_date).format("MM/DD/YYYY h:mm A");
  }
};

const PdfSurveyStartDate = (start_date) => {
  if (Number(moment(start_date).startOf("day").diff(moment(Date.now()).startOf("day"), "days")) < 1) {
    return "Opened on:\n" + moment(start_date).format("MM/DD/YYYY h:mm A");
  } else {
    return "Opens on:\n" + moment(start_date).format("MM/DD/YYYY h:mm A");
  }
};

const PdfSurveyEndDate = (end_date) => {
  if (Number(moment(end_date).startOf("day").diff(moment(Date.now()).startOf("day"), "days")) < 1) {
    return "Closed on:\n" + moment(end_date).format("MM/DD/YYYY h:mm A");
  } else {
    return "Closes on:\n" + moment(end_date).format("MM/DD/YYYY h:mm A");
  }
};

const companyLogoSrc = (companyLogoURL) => {
  return companyLogoURL;

  //return "https://api.openeyessurveys.com/public/company_logo/97ce6c01-00cf-459a-b9c1-ab7c5a2a3e2e/1669132138.TiEDC-logo-whitebg.png";
};

export {
  DateFormat,
  DaysDifferent,
  SurveyStartDate,
  SurveyEndDate,
  SurveyNote,
  PdfSurveyStartDate,
  PdfSurveyEndDate,
  companyLogoSrc,
  EncodeImageDataUrl,
  ExcelSurveyStartLabel,
  ExcelSurveyEndLabel,
  ExcelSurveyStartDate,
  ExcelSurveyEndDate,
};
